import { normalizarData, normalizarValor } from '../../utils';

/**
 * Retorna TRUE se a primeira linha tiver 'EXTRATO CONTA CORRENTE' (Asinatura Clássica do Sicoob)
 */
export const detectar = (dadosArray) => {
    // No Sicoob, a célula A1 costuma ter "EXTRATO CONTA CORRENTE" e o cabeçalho real fica na linha 2.
    if (dadosArray && dadosArray.length > 0) {
        const primeiraLinha = dadosArray[0];
        if (Array.isArray(primeiraLinha) && primeiraLinha.length > 0) {
            const A1 = String(primeiraLinha[0] || '').trim().toUpperCase();
            if (A1.includes('EXTRATO CONTA CORRENTE')) {
                return true;
            }
        }
    }

    // Fallback: Tenta achar o cabeçalho Sicoob (DATA e VALOR)
    for (let i = 0; i < Math.min(dadosArray.length, 5); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const str = linha.map(col => String(col || '').toUpperCase().trim());
        if (str[0] === 'DATA' && str.includes('VALOR')) {
            return true;
        }
    }

    return false;
};

/**
 * Processa a planilha bruta e retorna array mapeado.
 */
export const processar = (dadosArray) => {
    let idxCabecalho = -1;
    let idxData = 0;  
    let idxHistorico = 2; 
    let idxValor = 3; 
    let idxInfoComp = -1;
    let isNovoLayout = false;

    for (let i = 0; i < Math.min(dadosArray.length, 5); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const str = linha.map(col => String(col || '').toUpperCase().trim());
        const tempIdxHistorico = str.findIndex(c => c.includes('HISTÓRICO') || c.includes('HISTORICO'));
        const tempIdxInfoComp = str.findIndex(c => c.includes('INFORMAÇÕES COMPLEMENTARES') || c.includes('INFORMACOES COMPLEMENTARES'));
        const tempIdxValor = str.findIndex(c => c === 'VALOR' || c.includes('VALOR'));
        
        if (str[0] === 'DATA' && tempIdxValor !== -1) {
            idxCabecalho = i;
            if (tempIdxHistorico !== -1) idxHistorico = tempIdxHistorico;
            idxValor = tempIdxValor;
            if (tempIdxInfoComp !== -1) {
                idxInfoComp = tempIdxInfoComp;
                isNovoLayout = true;
            }
            break;
        }
    }

    if (idxCabecalho === -1) {
        throw new Error('Cabeçalho de Extrato Sicoob não encontrado. Esperava-se "DATA" na coluna A e "VALOR".');
    }

    const extrato = [];
    for (let i = idxCabecalho + 1; i < dadosArray.length; i++) {
        const linha = dadosArray[i];
        if (!linha || linha.length === 0) continue;

        const dataStr = String(linha[idxData] || '').trim();
        if (!dataStr) continue;

        // Ignora linhas de rodapé ou saldos que possam quebrar o cálculo
        const historicoStr = String(linha[idxHistorico] || '').toUpperCase();
        if (historicoStr.includes('SALDO') || dataStr.toUpperCase().includes('SALDO')) {
            continue;
        }

        const data = normalizarData(dataStr);
        if (!data) continue;

        let rawVal = linha[idxValor];
        let valorStr = String(rawVal || '').trim().toUpperCase();
        if (!valorStr) continue;

        let valor = null;
        let tipoFallback = 'indefinido';

        if (isNovoLayout) {
            // O novo modelo não traz letras "C" ou "D", apenas sinais matemáticos.
            if (typeof rawVal === 'number') {
                if (rawVal < 0) continue; // Ignora débitos (valores negativos)
                valor = rawVal;
            } else {
                if (valorStr.includes('-')) continue; // Ignora débitos
                valor = normalizarValor(valorStr);
            }
            tipoFallback = 'crédito';
        } else {
            // O Sicoob antigo coloca C ou D no final do valor numérico
            if (valorStr.endsWith('C')) {
                tipoFallback = 'crédito';
                valorStr = valorStr.replace(/C$/, '').trim();
            } else if (valorStr.endsWith('D')) {
                continue; // Nós ignoramos débitos no cálculo de repasses
            } else {
                continue; // Se não tem C ou D no final o parser ignora
            }
            valor = normalizarValor(valorStr);
        }

        if (valor === null || valor <= 0) continue;

        let descricao = '';
        if (isNovoLayout) {
            // A descrição no formato novo vem na coluna de info complementar (na mesma linha)
            descricao = String(linha[idxInfoComp] || linha[idxHistorico] || '').trim();
        } else {
            // A descrição detalhada no formato antigo fica na linha de baixo
            if (i + 1 < dadosArray.length && Array.isArray(dadosArray[i + 1])) {
                descricao = String(dadosArray[i + 1][idxHistorico] || '').trim();
            }
        }
        
        let tipo = descricao || tipoFallback;
        // Limpa quebras de linha caso a descrição venha formatada com \n 
        tipo = tipo.replace(/\r?\n|\r/g, ' - ');

        extrato.push({
            linha: i + 1,
            data: data,
            valor: valor,
            tipo: tipo,
            dataOriginal: dataStr,
            valorOriginal: String(rawVal || '').trim()
        });
    }

    return extrato;
};
